import { memo, useMemo } from 'react'
import Modal from '@/components/interface/Modal/Modal'
import { useModalContext } from '@/components/interface/Modal/provider/ModalProvider'
import ModalBuyersGuide from './modal/BuyersGuide/ModalBuyersGuide'
import ModalNewsletter from './modal/ModalNewsletter/ModalNewsletter'

/**
 * The `AppModals`
 * @returns {React.ReactElement} the element
 */
function AppModals () {
  const { modalId, modalRef, props } = useModalContext()

  const output = useMemo(() => {
    if (!modalRef.current) {
      return null
    }

    if (modalId === 'app:newsletter') {
      return (
        <Modal.Portal>
          <ModalNewsletter />
        </Modal.Portal>
      )
    }

    if (modalId === 'app:buyersguide') {
      return (
        <Modal.Portal>
          <ModalBuyersGuide />
        </Modal.Portal>
      )
    }
  }, [modalId, props])

  return output
}

export default memo(AppModals)
